'use strict';

import React, { Component } from 'react';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
let app = window.app;
export default class Breadcrumb extends Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const items = (props.links || []).map(function (config, i) {
      const label = /*#__PURE__*/React.createElement("span", {
        className: "c-breadcrumb__label",
        property: "name"
      }, config.label);
      const output = /*#__PURE__*/React.createElement("li", {
        className: "c-breadcrumb__item",
        key: config.name,
        property: "itemListElement",
        typeof: "ListItem"
      }, /*#__PURE__*/React.createElement(Link, {
        href: config.url,
        className: "c-breadcrumb__link",
        property: "item",
        typeof: "WebPage"
      }, label), /*#__PURE__*/React.createElement("meta", {
        property: "position",
        content: String(i + 1)
      }));
      return output;
    });
    let output = /*#__PURE__*/React.createElement("nav", {
      className: bemit('c-breadcrumb', props.bemit) + ' ' + (props.className || '')
    }, /*#__PURE__*/React.createElement("ol", {
      className: "c-breadcrumb__content",
      vocab: "https://schema.org/",
      "aria-label": "breadcrumbs"
    }, items));
    return output;
  }
}
